// pages/module-pages/faq/NewFaqPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import FaqForm from "../../../components/shared/faqs/FaqForm";
import { BaseFaq } from "../../../types/features/Faq";
import useFaqs from "../../../hooks/features/faqs/useFaqs";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { alertSuccess } from "../../../helpers/alertError";

export default function NewFaqPage() {
  const { createFaq } = useFaqs();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = async (data: BaseFaq) => {
    setIsLoading(true);
    const slug = data.question
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");

    const success = await createFaq({ ...data, slug });
    setIsLoading(false);
    if (success) {
      alertSuccess("Une FAQ ajoutée avec succès");
      setIsSuccess(true);
    }
  };

  return (
    <PageLayout title="Ajouter une FAQ" className="p-6 max-w-4xl mx-auto">
      <PageContainer>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Nouvelle FAQ</h1>
          <p className="text-gray-500 mt-1">Ajoutez une question fréquemment posée</p>
        </div>
        <FaqForm isSuccess={isSuccess} onSubmit={handleSubmit} isLoading={isLoading} />
      </PageContainer>
    </PageLayout>
  );
}
